import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";

const Seo = ({ title, description }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const siteTitle = data.site.siteMetadata.title;


  // Function to remove "| McKinley.com" from the end of the title
  const cleanTitle = (title) => {
    title = title.replace("0 bedrooms 1 bath", "Studio Apartment");
    const regex = new RegExp(`\\s*\\|\\s*${siteTitle}\\s*$`, "i");
    return title.replace(regex, "").trim();
  };


  const finalTitle = `${cleanTitle(title)} | ${siteTitle}`;


  return (
    <>
      <title>{finalTitle}</title>

      {description && <meta name="description" content={description} />}
    </>
  );
};

export default Seo;
